/**
 * Commonly used functions for cross browser window, document, or html attribute manipulation
 */
import root from 'window-or-global';

/**
 * Function to get the data attribute that is compatible with IE
 * @param element
 * @param attributeName
 */
export function getDataAttribute(element, attributeName) {
    if (!element || !attributeName) return null;
    return element.dataset ? element.dataset[attributeName] : element.getAttribute(`data-${attributeName}`);
}

export function setDataAttribute(element, attributeName, value) {
    if (!element || !attributeName || !value) return null;
    if (element.dataset) {
        element.dataset[attributeName] = value;
    } else {
        element.setAttribute(`data-${attributeName}`, value);
    }
    return 1;
}

/**
 * Function to get root.location.origin that is compatible with IE 9/10
 */
export function getWindowLocationOrigin() {
    if (!root.location.origin) {
        const port = (root.location.port ? `:${root.location.port}` : '');
        root.location.origin = `${root.location.protocol}//${root.location.hostname}${port}`;
        return root.location.origin;
    }
    return root.location.origin;
}


export const getWindowWidth = () => {
    const innerWindowWidth = root.innerWidth;
    const clientWidth = document.documentElement.clientWidth || document.getElementsByTagName('body')[0].clientWidth;
    if (clientWidth < innerWindowWidth) {
        return innerWindowWidth; //accounts for scroll bars
    }
    return clientWidth; //accounts for pinch to zoom
};


export const getWindowHeight = () => {
    const innerHeight = root.innerHeight;
    const clientHeight = document.documentElement.clientHeight || document.getElementsByTagName('body')[0].clientHeight;
    if (clientHeight < innerHeight) {
        return innerHeight;
    }
    return clientHeight;
};

export const getElement = (elementParam) => {
    if (!elementParam) return null;

    let element;
    if (typeof elementParam === 'string') {
        element = document.getElementById(elementParam) || null;
    } else if (typeof elementParam === 'object' && elementParam.offsetWidth) {
        element = elementParam;
    } else {
        console.warn('getElement() could not obtain an element from the parameter passed. Requires an ID or a DOM node.');
    }
    return element;
};

export const getOuterWidth = (elementParam) => {
    const element = getElement(elementParam);

    const getMargin = (prop) => {
        let marginValue = 0;

        if (!element || !prop) {
            return marginValue;
        }

        try {
            if (root.getComputedStyle) {
                const style = root.getComputedStyle(element) || {};
                marginValue = style.getPropertyValue(prop) || 0;
            } else if (element.currentStyle) {
                marginValue = element.currentStyle[prop];
            }
        } catch (e) {
            //Couldn't get margin
        }

        marginValue = marginValue.replace('px', '');
        return +marginValue;
    };

    let width = 0;
    if (element) {
        width = element.offsetWidth ? element.offsetWidth : 0;
        width += getMargin('margin-left');
        width += getMargin('margin-right');
    }

    return width;
};

export const getInnerWidth = (elementParam) => {
    const element = getElement(elementParam);
    let width = 0;
    if (element) {
        width = element.offsetWidth ? element.offsetWidth : 0;
    }
    return width;
};

/**
 * If the delta for the x or y coordinates of the mouse have changed from mouse down to mouse up
 *  it is dragging motion and not intended to be a click.
 * @param  {Object} e Event object
 * @return {Boolean}   true/false
 */
export function draggingMotion(e, mouseDown) {
    const allowed = 40;
    const x = e.clientX;
    const y = e.clientY;

    if (mouseDown) {
        if (Math.abs(x - mouseDown.x) > allowed) {
            return true;
        }

        if (Math.abs(y - mouseDown.y) > allowed) {
            return true;
        }
    }

    return false;
}

export const getBowserState = () => {
    const mobile = root._epicGamesNav && root._epicGamesNav.browser ? root._epicGamesNav.browser.mobile : false;
    const tablet = root._epicGamesNav && root._epicGamesNav.browser ? root._epicGamesNav.browser.tablet : false;
    const msie = root._epicGamesNav && root._epicGamesNav.browser ? root._epicGamesNav.browser.msie : false;
    const firefox = root._epicGamesNav && root._epicGamesNav.browser ? root._epicGamesNav.browser.firefox : false;

    return {
        mobile: mobile || false,
        tablet: tablet || false,
        msie: msie || false,
        firefox: firefox || false
    };
};

export function isMobile() {
    const epicGamesNavInfo = root._epicGamesNav;
    const browser = epicGamesNavInfo.browser;
    return browser && browser.mobile;
}

export function isTablet() {
    const epicGamesNavInfo = root._epicGamesNav;
    const browser = epicGamesNavInfo.browser;
    return browser && browser.tablet;
}
